import {WeaInput} from 'ecCom';
import {Button} from 'antd';

class Main extends React.Component {
  constructor(props) {
    super(props);
  }
  onBtnClick() {
    this.props.onBtnClick &&　this.props.onBtnClick(this.props.value);
  }
  render() {
    const {props} = this;
    const {viewAttr} = props;
    return (
      <div className="hrm-input-btn">
        <WeaInput {...props} />
        {
          viewAttr!='1' && <Button type="primary" onClick={this.onBtnClick.bind(this)}>{props.btnText}</Button>
        }
      </div>
    )
  }
}
export default Main;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/coms/inputBtn.js